import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class HeizungsrohreJahr extends AbstractRequirementMapper {
  protected frontendKey = 'sanierungen.heizungsrohreJahr';

  public getValues(): number[] {
    return super.getValues().map((v) => Number.parseInt(<string>v, 10));
  }
}
